<h2 mat-dialog-title>{{ 'FORM_V2.CONFLICT_DIALOG.TITLE' | translate }}</h2>
<mat-dialog-content>
  <p>{{ 'FORM_V2.CONFLICT_DIALOG.MESSAGE' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>{{ 'FORM_V2.CONFLICT_DIALOG.CLOSE' | translate }}</button>
  <button mat-flat-button color="primary" (click)="handleRefreshPage()">
    {{ 'FORM_V2.CONFLICT_DIALOG.REFRESH' | translate }}
  </button>
</mat-dialog-actions>
